import { fetchRequestWithTypes } from './index.js';

export const POST_DEBIT_REQUEST = 'POST_DEBIT_REQUEST';
export const POST_DEBIT_SUCCESS = 'POST_DEBIT_SUCCESS';
export const POST_DEBIT_ERRORED = 'POST_DEBIT_ERRORED';

export const postDebit = (cardData) =>
	fetchRequestWithTypes({
		types: [POST_DEBIT_REQUEST, POST_DEBIT_SUCCESS, POST_DEBIT_ERRORED],
		request: {
			method: 'POST',
			path: `/plastic/api/v1/users/:uuid/funding_sources`,
			body: {
				funding_source: {
					card: {
						name_on_card: cardData.name_on_card,
						token: cardData.token,
						last_four: cardData.lastFour,
						expiration_date: cardData.expirationDate,
					},
					billing_address: {
						// We allow users to enter a different zip code from their home address
						postal_code: cardData.zipcode,
					},
				},
				credit_cards_allowed: true,
				prepaid_cards_allowed: true,
			},
		},
	});
